import { Configuration, PopupRequest } from '@azure/msal-browser';

const REACT_APP_CLIENT_ID = process.env.REACT_APP_CLIENT_ID || '';

export const msalConfig: Configuration = {
  auth: {
    clientId: REACT_APP_CLIENT_ID, // see first step where you registered the App
    authority: 'https://login.microsoftonline.com/ea80952e-a476-42d4-aaf4-5457852b0f7e', // Primary domain of your Active Directory,
    redirectUri: '/',
    postLogoutRedirectUri: '/',
  },
  system: {
    allowNativeBroker: false,
  },
};

export const loginRequest: PopupRequest = {
  scopes: [`api://${REACT_APP_CLIENT_ID}/Read`],
};
